import { SxProps, useTheme } from "@mui/material";

export const usePageSxProps = () => {
  const theme = useTheme();

  return {
    listPageSx: {
      overflow: "hidden",
      padding: 1.5,
      // paddingTop: 2.5,
      [theme.breakpoints.down("sm")]: {
        padding: 0,
      },
    } as SxProps,
    singlePageSx: {
      padding: 1.5,
      [theme.breakpoints.down("sm")]: {
        paddingX: 1,
      },
    } as SxProps,
  };
};
